import FullmaktSkjema from "./FullmaktSkjema";
import { useRegistreringContext } from "../../Registreringsflyt/useRegistreringContext";

export function Fullmakt() {
  const { integrasjonsPartner, valgtForetak, previousStep, nextStep, reset } =
    useRegistreringContext();

  if (!integrasjonsPartner || !valgtForetak) {
    return reset();
  }

  return (
    <FullmaktSkjema
      integrasjonsPartner={integrasjonsPartner}
      registrerendeBedrift={valgtForetak}
      goBack={previousStep}
      accept={nextStep}
    />
  );
}
